import type { FC } from 'react';
import { memo } from 'react';
import { Picture } from '@ui';
import { checkSmallWhite } from '@images';
import { twcls } from '@utils/twcls';

interface ToggleWithLabelProps {
  onChange: () => void;
  label: string;
  isChecked: boolean;
  disabled?: boolean;
  className?: string;
}

const ToggleWithLabel: FC<ToggleWithLabelProps> = ({
  onChange,
  isChecked,
  label,
  disabled,
  className
}) => (
  <button
    disabled={disabled}
    onClick={onChange}
    className={twcls(
      `group w-full justify-between cursor-pointer flex items-center gap-2 rounded-lg border py-3 bg-transparent disabled:text-[var(--mid-grey)]`,
      className
    )}
  >
    <span className='font-medium'>{label}</span>
    <label className='relative inline-block w-12 h-6'>
      <div
        className={twcls(
          'opacity-0 w-0 h-0 group-disabled:bg-[var(--mid-grey)]',
          isChecked && 'bg-[#B32442] before:bg-white before:translate-x-5 z-[1]'
        )}
      />
      <span
        className={twcls(
          `
          group-disabled:bg-[var(--mid-grey)]
          absolute
          cursor-pointer
          top-0
          left-0
          right-0
          bottom-0
          bg-[#C2C2C2]
          duration-300
          rounded-xl
          before:absolute
          before:top-[4px]
          before:left-[4px]
          before:content-[""]
          before:right-auto
          before:h-[16px]
          before:w-[16px]
          before:bg-white
          before:z-[3]
          before:rounded-full`,
          isChecked && 'bg-[#B32442] before:right-[4px] before:left-auto'
        )}
      />
      {isChecked && (
        <Picture
          className={twcls(
            'cursor-pointer absolute top-1 left-[4px] right-auto z-[2]'
          )}
          icon={checkSmallWhite}
          height={16}
          width={16}
        />
      )}
    </label>
  </button>
);

export default memo(ToggleWithLabel);
